import Head from "next/head";
import Link from "next/link";
import useWeb3Tokens from "../hooks/useWeb3Tokens";

import useWalletCheckTrigger from "../hooks/useWalletCheckTrigger";

import Gallery from "../components/Gallery";
import WalletButton from "../components/WalletButton";
import { WALLET_GCLOUD_STORAGE_BUCKET } from "../constants";

export default function Wallet() {
	const { tokens, loaded, connected } = useWeb3Tokens();
	const items = tokens.map((tokenId) => {
		return {
			externalUrl: `https://storage.googleapis.com/${WALLET_GCLOUD_STORAGE_BUCKET}/images/${tokenId}.png`,
			name: tokenId,
		};
	});

	useWalletCheckTrigger();

	return (
		<>
			<Head>
				<title key="title">Wallet | Lucien Smith - Seeds</title>
			</Head>

			<div className="w-full max-w-screen-lg mx-auto px-4 xl:px-0 mt-6" id="wallet">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">MY WALLET</h1>
				<p className="mt-6">Connect your wallet to view Seeds packets that you have minted</p>
				<div className="flex justify-center mt-12">
					<WalletButton
						className="rounded border-2 border-primary p-4 whitespace-nowrap overflow-ellipsis max-w-full mx-4 overflow-hidden"
						inactive="bg-white text-primary"
						active="bg-primary text-white"
					>
						Connect your wallet
					</WalletButton>
				</div>
				<div className="flex flex-col justify-center items-center mt-12 relative">
					{connected && !loaded && <div className="text-2xs animate-pulse bg-primary p-2 mb-2 text-white">Syncing...</div>}
					{items.length > 0 && <Gallery items={items} />}
					{loaded && connected && items.length < 1 && <p>You do not have any SEEDs in your wallet.</p>}
				</div>
			</div>
		</>
	);
}
